(() => {
  if (customElements.get('nm-winterization-form')) return;

  customElements.define('nm-winterization-form', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.initialized = true;
      this.rows = [...this.querySelectorAll('[data-price]')];
      this.output = this.querySelector('[data-subtotal]');
      this.submittedSubtotal = this.querySelector('[data-subtotal-input]');
      this.quoteNote = this.querySelector('[data-quote-note]');
      this.money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

      this.rows.forEach((row) => this.syncQuantity(row));
      this.form.addEventListener('change', (event) => {
        const row = event.target.closest('[data-price]');
        if (row && event.target.type === 'checkbox') this.syncQuantity(row);
        this.updateEstimate();
      });
      this.form.addEventListener('input', () => this.updateEstimate());
      this.form.addEventListener('submit', () => this.updateEstimate());
      this.form.addEventListener('reset', () => {
        // The reset event fires before the browser restores field values.
        setTimeout(() => {
          this.rows.forEach((row) => this.syncQuantity(row));
          this.updateEstimate();
        }, 0);
      });
      this.updateEstimate();
      this.querySelector('[data-estimate]').hidden = false;
    }

    syncQuantity(row) {
      const quantity = row.querySelector('input[type="number"]');
      if (!quantity) return;
      const selected = row.querySelector('input[type="checkbox"]').checked;
      quantity.disabled = !selected;
      quantity.required = selected;
      // Selecting a per-item service starts with one item, visibly and in the submission.
      if (selected && quantity.value === '') quantity.value = '1';
    }

    updateEstimate() {
      let cents = 0;
      let valid = true;
      let needsQuote = false;
      this.rows.forEach((row) => {
        if (!row.querySelector('input[type="checkbox"]').checked) return;
        if (row.dataset.price === 'quote') {
          needsQuote = true;
          return;
        }
        const quantity = row.querySelector('input[type="number"]');
        if (quantity && (quantity.value === '' || !quantity.validity.valid)) {
          valid = false;
          return;
        }
        cents += Number(row.dataset.price) * (quantity ? Number(quantity.value) : 1);
      });

      const amount = this.money.format(cents / 100);
      const message = valid ? amount : 'Enter a valid quantity for each selected service to see your subtotal.';
      if (this.output.textContent !== message) this.output.textContent = message;
      this.quoteNote.hidden = !needsQuote;
      this.submittedSubtotal.disabled = !valid;
      this.submittedSubtotal.value = valid ? `${amount}${needsQuote ? ' + services requiring a quote' : ''}` : '';
    }
  });
})();
